// src/components/purchase/PurchaseHud.jsx
import React from "react";
import { usePurchaseStore } from "../../stores/usePurchaseStore";

export default function PurchaseHud() {
  const totals = usePurchaseStore(s => s.totals)();
  const activeGrid = usePurchaseStore(s => s.activeGrid);

  const gridLabel = activeGrid === "us48" ? "Imagery grid" : "TX Survey";

  return (
    <div className="absolute top-3 left-1/2 -translate-x-1/2 pointer-events-none z-[80]">
      <div className="bg-slate-900/90 border border-slate-700 rounded-md
                      px-4 py-2 shadow-xl shadow-black/40
                      flex items-center gap-5 text-[11px]">
        <div className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-info animate-pulse" />
          <span className="font-mono uppercase tracking-wider text-slate-400">
            Purchase · {gridLabel}
          </span>
        </div>
        <Divider />
        <Metric label="Blocks" value={totals.blocks.toLocaleString()} />
        <Divider />
        <Metric label="Area"   value={`${totals.sqMi.toFixed(2)} sq mi`} />
        <Divider />
        <Metric
          label="Est."
          value={totals.price == null ? "—" : `$${totals.price.toFixed(2)}`}
          muted
        />
      </div>
    </div>
  );
}

function Metric({ label, value, muted }) {
  return (
    <div className="flex items-baseline gap-1.5">
      <span className="text-[10px] font-mono uppercase tracking-wider text-fg-secondary">{label}</span>
      <span className={`tabular-nums font-medium ${muted ? "text-fg-secondary" : "text-gray-100"}`}>
        {value}
      </span>
    </div>
  );
}

function Divider() {
  return <span className="w-px h-3.5 bg-slate-700" />;
}